import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { checkMp4Support } from '@/entities/interwills/hooks/useWebcamRecorder/config';
import { media } from '@/shared/components';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { RecordingWarningModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const RecordingWarningModal: FC<RecordingWarningModalProps> = ({ role, fullname }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'recordingWarning' });

  const modals = useModalsStore();

  return (
    <ModalContainerV2 pinBottom title={t('title', { role, fullname })}>
      <InnerForm>
        <span>{t('text')}</span>
      </InnerForm>
      <Buttons>
        <ButtonIw onClick={modals.closeModal} type="default">
          {t('cancel')}
        </ButtonIw>
        <ButtonIw
          onClick={() => {
            const type = checkMp4Support() ? 'RecordingModal' : 'RecordingUnavailableModal';

            modals.closeModal();
            modals.openModal({
              type,
            });
          }}
        >
          {t('ready')}
        </ButtonIw>
      </Buttons>
    </ModalContainerV2>
  );
};

const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 24px 0;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  ${media.iwMobile} {
    flex-direction: column-reverse;
  }
`;
